import { tokens } from '@cellula/react-theme-patient';
import { motion, AnimatePresence } from 'framer-motion';
import styled from 'styled-components';

interface Props {
	isSelected: boolean;
}

const elements = {
	illustrativeSelection: styled(motion.div)`
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		border: 2px solid ${tokens.color.bg.interactive};
		border-radius: 12px;
		user-select: none;
		pointer-events: none;
	`,
};

export function IllustrativeSelection({ isSelected }: Props): JSX.Element {
	return (
		<AnimatePresence>
			{isSelected ? (
				<elements.illustrativeSelection
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{
						opacity: 0,
						transition: {
							duration: 0.1,
						},
					}}
					transition={{ type: 'spring' }}
				/>
			) : null}
		</AnimatePresence>
	);
}
